export function getShortCodeDomainFromURL(url) {
  const urlObject = new URL(url);
  return urlObject.hostname;
}
